module.exports = __webpack_public_path__ + "img/customers.ae5a5cc8.png";